import { render, staticRenderFns } from "./FeedbackListEntry.vue?vue&type=template&id=21a7a4a8"
import script from "./FeedbackListEntry.vue?vue&type=script&lang=js"
export * from "./FeedbackListEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports